var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.885 22a1.06 1.06 0 0 1-.784-.32 1.08 1.08 0 0 1-.316-.791V19.61a5.7 5.7 0 0 1-2.173-.972q-.934-.694-1.512-1.945a.95.95 0 0 1-.014-.819q.18-.43.646-.625a.96.96 0 0 1 .798.014q.413.18.632.597.468.834 1.183 1.264t1.76.43q1.128 0 1.911-.513.784-.514.784-1.598 0-.972-.605-1.541-.604-.57-2.805-1.292-2.365-.75-3.245-1.792-.88-1.041-.88-2.541 0-1.806 1.155-2.806t2.365-1.139V3.111q0-.473.316-.792T11.885 2t.784.32q.315.318.316.791v1.222q1.045.167 1.815.68a4.5 4.5 0 0 1 1.265 1.265q.247.36.096.805-.15.445-.619.64a1.03 1.03 0 0 1-.797.013 2 2 0 0 1-.77-.542 2.45 2.45 0 0 0-.839-.597q-.481-.208-1.196-.208-1.21 0-1.843.542-.632.54-.632 1.347 0 .916.825 1.444t2.86 1.111q1.897.556 2.874 1.764.975 1.209.976 2.792 0 1.973-1.155 3-1.155 1.028-2.86 1.278v1.222q0 .473-.316.792a1.06 1.06 0 0 1-.784.319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachMoney);
export default __webpack_public_path__ + "static/media/attach_money.d524b9e199f42078393e03c325607372.svg";
export { ForwardRef as ReactComponent };